"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Region = void 0;
/**
 * The commercetools region that your API client id/secret relate to.
 * This is used to determine the authentication endpoint.
 */
var Region;
(function (Region) {
    Region["NORTH_AMERICA_GCP"] = "north_america_gcp";
    Region["NORTH_AMERICA_AWS"] = "north_america_aws";
    Region["EUROPE_GCP"] = "europe_gcp";
    Region["EUROPE_AWS"] = "europe_aws";
    Region["AUSTRALIA_GCP"] = "australia_gcp";
})(Region = exports.Region || (exports.Region = {}));
//# sourceMappingURL=types.js.map